import React, { useEffect, useRef, useState } from "react";

/**
 * Subtle scroll-reveal wrapper. Fades + slides up once in view.
 */
export default function Reveal({ children, delay = 0, as: Tag = "div", className = "", ...rest }) {
    const ref = useRef(null);
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        const node = ref.current;
        if (!node) return;
        const obs = new IntersectionObserver(
            (entries) => {
                entries.forEach((e) => {
                    if (e.isIntersecting) {
                        setVisible(true);
                        obs.unobserve(e.target);
                    }
                });
            },
            { threshold: 0.12, rootMargin: "0px 0px -60px 0px" }
        );
        obs.observe(node);
        return () => obs.disconnect();
    }, []);

    return (
        <Tag
            ref={ref}
            style={{ transitionDelay: `${delay}ms` }}
            className={`reveal ${visible ? "in-view" : ""} ${className}`}
            {...rest}
        >
            {children}
        </Tag>
    );
}
